var styles = {"box":"Verification_box_bjka7_1","box__inner":"Verification_box__inner_bjka7_4","captcha-wrapper":"Verification_captcha-wrapper_bjka7_9","code-btn":"Verification_code-btn_bjka7_16"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
